{
  "title": "Reglas de asignación",
  "subtitle": "Se evalúan de arriba abajo. La primera regla que coincida con un remitente gana y la evaluación se detiene.",
  "newRule": "Nueva regla",
  "testRules": "Probar un remitente",
  "loadError": "No se pudieron cargar las reglas",
  "emptyTitle": "Aún no hay reglas",
  "emptyBody": "Sin un valor predeterminado ni una regla, no se estampa nada: cada mensaje se retransmite sin cambios. Establece una firma predeterminada en Usuarios, o añade una regla más específica aquí.",
  "tenantDefault": "Valor predeterminado del inquilino",
  "tenantDefaultHint": "Se aplica cuando ninguna regla de operador coincide.",
  "reorderError": "No se pudo reordenar las reglas.",
  "reorderFailed": "Error al reordenar.",
  "deleteRule": "Eliminar regla",
  "deleteConfirm": "¿Eliminar «{{name}}»?",
  "deleted": "Se eliminó \"{{name}}\".",
  "deleteError": "No se pudo eliminar esa regla.",
  "editRule": "Editar «{{name}}»",
  "createRule": "Nueva regla",
  "ruleName": "Nombre",
  "ruleNamePlaceholder": "Ventas — aviso externo",
  "enabled": "Activada",
  "disabled": "Desactivada",
  "template": "Plantilla",
  "injectionMode": "Ruta de inyección",
  "injectionBoth": "Ambas",
  "injectionBothPaths": "Ambas rutas",
  "injectionMailFlow": "Solo flujo de correo",
  "injectionClient": "Solo cliente",
  "injectionMailFlowShort": "Flujo de correo",
  "injectionClientShort": "Cliente",
  "unknownPath": "Ruta desconocida",
  "recipientScope": "Destinatarios",
  "recipientAny": "Cualquiera",
  "recipientAnyFull": "Cualquier destinatario",
  "recipientInternal": "Solo internos",
  "recipientExternal": "Solo externos",
  "unknownRecipients": "Destinatarios desconocidos",
  "recipientsHint": "Se juzga por el sobre. Un mensaje sin destinatarios no cumple interno ni externo, así que una regla con ámbito simplemente no coincide en lugar de adivinar.",
  "templateNew": "Firma para mensajes nuevos",
  "templateNewShort": "Nuevo: {{name}}",
  "templateNewNone": "Nuevo: sin plantilla",
  "templateReply": "Firma para respuestas",
  "templateReplyShort": "Respuesta: {{name}}",
  "templateReplySame": "Respuesta: igual que nuevo",
  "templateNone": "Ninguna",
  "templateReplyPlaceholder": "Igual que mensajes nuevos",
  "unknownTemplate": "Plantilla desconocida",
  "appliesTo": "Se aplica a",
  "except": "Excepto",
  "emptyScopeTitle": "Esta regla no coincide con nadie",
  "emptyScopeBody": "Un ámbito vacío nunca se dispara. Elige al menos una faceta, o activa Todos.",
  "emptyScopeBadge": "No coincide con nadie",
  "emptyScopeTooltip": "Un ámbito de remitente vacío no coincide con nadie, así que esta regla nunca se dispara.",
  "hasExclusions": "Tiene exclusiones",
  "addExclusions": "Añadir exclusiones",
  "removeExclusions": "Quitar exclusiones",
  "exclusionsHint": "Los remitentes excluidos pasan a reglas de menor prioridad en lugar de perder la firma por completo.",
  "saveRule": "Guardar regla",
  "saved": "Regla guardada.",
  "saveError": "No se pudo guardar la regla",
  "testerTitle": "Probar un remitente",
  "testerHint": "Elige un buzón para ver qué regla ganaría y qué firma recibirían.",
  "senderAddress": "Dirección del remitente",
  "senderPlaceholder": "jordan.avery@contoso.com.au",
  "recipientsLabel": "Destinatarios",
  "recipientsDescription": "Destinatarios del sobre. Las reglas solo internos/externos se juzgan con estos.",
  "recipientsPlaceholder": "Añade un destinatario y pulsa Intro",
  "runTest": "Ejecutar prueba",
  "testError": "No se pudo ejecutar la prueba",
  "noRuleMatched": "Ninguna regla coincidió",
  "noRulesEvaluated": "No se evaluó ninguna regla.",
  "colPriority": "Prioridad",
  "colRule": "Regla",
  "colOutcome": "Resultado",
  "colWhy": "Por qué",
  "traceMatched": "Coincidió",
  "traceShadowed": "En sombra",
  "traceDisabled": "Desactivada",
  "traceSenderOutOfScope": "Remitente fuera de ámbito",
  "traceExcludedByRule": "Excluido por la regla",
  "traceRecipientScope": "Ámbito de destinatarios",
  "traceWrongPath": "Ruta incorrecta",
  "traceNotEvaluated": "No evaluada",
  "traceUnknown": "Desconocido",
  "excludedTitle": "El remitente está excluido",
  "excludedBody": "Esta dirección está marcada como excluida en el directorio, así que su correo se retransmite intacto y no se evalúa ninguna regla. No hay nada que rastrear.",
  "excludedHint": "La exclusión se define en el usuario del directorio, no en estas reglas. Quítala allí si este remitente debe estamparse.",
  "primaryDefault": "Predeterminado principal",
  "defaultBadge": "Predeterminado",
  "everyone": "Todos",
  "noMailboxesCovered": "Aún no hay buzones cubiertos.",
  "mailboxesCovered": "{{count}} buzón cubierto.",
  "mailboxesCovered_other": "{{count}} buzones cubiertos.",
  "mailboxesCoveredWithCustom": "{{count}} buzón cubierto, {{custom}} con firma individual.",
  "mailboxesCoveredWithCustom_other": "{{count}} buzones cubiertos, {{custom}} con firma individual.",
  "managedOnUsers": "Gestionado en la",
  "usersTab": "pestaña Usuarios",
  "changeDefault": "Cambiar predeterminado",
  "reorderAria": "Reordenar {{name}}",
  "moreActionsAria": "Más acciones para {{name}}",
  "edit": "Editar",
  "facetEveryone": "Todos",
  "facetUsers": "Usuarios",
  "facetGroups": "Grupos",
  "facetDomains": "Dominios",
  "facetConditions": "Condiciones",
  "everyoneLabel": "Aplicar a todos en el inquilino",
  "everyoneDescription": "El comodín explícito. Sin él, un ámbito sin otras facetas no coincide con nadie.",
  "directoryUsers": "Usuarios del directorio",
  "searchUsers": "Buscar usuarios",
  "userExcludedSuffix": " (excluido)",
  "emailAddresses": "Direcciones de correo",
  "emailAddressesDescription": "Se comparan con cada dirección proxy, así que también resuelven alias y buzones compartidos.",
  "emailAddressesPlaceholder": "nombre@ejemplo.com",
  "groupsLabel": "Grupos",
  "searchGroups": "Buscar grupos",
  "groupsDescription": "La pertenencia anidada se aplana al sincronizar, así que un usuario en un grupo anidado coincide.",
  "senderDomains": "Dominios del remitente",
  "senderDomainsDescription": "Se compara con la parte de dominio de la dirección de envío.",
  "senderDomainsPlaceholder": "contoso.com.au",
  "conditionsEmptyHint": "Sin condiciones de atributo. Añade una para segmentar por departamento, oficina o un atributo personalizado.",
  "facetsUnionHint": "Las facetas se combinan como unión: cualquiera que coincida con alguna faceta está en el ámbito.",
  "match": "Coincidir",
  "attribute": "Atributo",
  "usersHaveValue": "{{count}} usuarios tienen un valor",
  "attributeNotSeen": "No visto en ningún usuario sincronizado",
  "value": "Valor",
  "valueInPlaceholder": "Ventas, Marketing",
  "removeCondition": "Quitar condición",
  "addCondition": "Añadir condición",
  "operatorEquals": "es",
  "operatorNotEquals": "no es",
  "operatorContains": "contiene",
  "operatorStartsWith": "empieza por",
  "operatorEndsWith": "termina en",
  "operatorIsEmpty": "está vacío",
  "operatorIsNotEmpty": "no está vacío",
  "operatorIn": "es uno de"
}
